import React, { FC } from 'react';
import styles from './search_filters_bar_action.module.scss';

export const SearchFiltersBarActions: FC = ({ children }) => {
  return <div className={styles.action}>{children}</div>;
};
